import axios from 'axios';
import { errorInterceptor, responseInterceptor } from './interceptors';

export const Api = () => {
  const api = axios.create({
    baseURL: '/ws/api',
  });

  // Interceptor de requisição para injetar o token mais recente
  api.interceptors.request.use(
    (config) => {
      const access_data = localStorage.getItem('APP_ACCESS_TOKEN');
      if (access_data) {
        const token = JSON.parse(access_data)['token'];
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  api.interceptors.response.use(
    (response) => responseInterceptor(response),
    (error) => errorInterceptor(error)
  );

  return api;
};
